export enum AnalyticsCustomEvents {
    ModelUploaded = 'model_uploaded',
    OrderStatusChange = 'order_status_change',
    OrderSubmitFormShippingTypeChange = 'order_submit_form_shipping_type_change',
    CartPageFinalized = 'cart_page_finalized',
    PaymentPageTransitionAttempted = 'payment_page_transition_attempted',
}
